/*global Stripe*/
import tests from "validator";
import { PhoneNumberUtil } from "google-libphonenumber/dist/libphonenumber";
import Marty from "marty";

let phone = PhoneNumberUtil.getInstance();

const SUBNET_MASK_REGEX = /^(255\.(0|128|192|224|240|248|252|254)\.0\.0)|(255\.255\.(0|128|192|224|240|248|252|254)\.0)|(255\.255\.255\.(0|128|192|224|240|248))$/;

tests.extend("isPhone", (value) => {
    let locales = ["US", "GB", "CA"],
        isValid;

    try {
        isValid = locales.some(locale => phone.isValidNumber(phone.parse(value, locale)));
    } catch (exception) {
        isValid = false;
    }

    return isValid;
});

tests.extend("isSubnetMask", value => {
    return SUBNET_MASK_REGEX.test(value);
});

let validators = {
    isEmailOptional(values, value) {
        return !value || tests.isEmail(value || "");
    },
    isEmail(values, value) {
        return tests.isEmail(value || "");
    },
    isIPOptional(values, value) {
        return !value || tests.isIP(value || "");
    },
    isPhone(values, value) {
        return tests.isPhone(value || "");
    },
    isPhoneOptional(values, value) {
        return !value || tests.isPhone(value || "");
    },
    isValidCreditCard(values, value) {
        return Marty.isBrowser ? Stripe.card.validateCardNumber(value || "") : false;
    },
    isValidCVC(values, value) {
        return Marty.isBrowser ? Stripe.card.validateCVC(value || "") : false;
    },
    isValidExpiry(values, value) {
        return Marty.isBrowser ? Stripe.card.validateExpiry(values.exp_month || "", values.exp_year || "") : false;
    },
    isIP(values, value) {
        return tests.isIP(value || "");
    },
    isSubnetMask(values, value) {
        return tests.isSubnetMask(value || "");
    },
    isInt(values, value) {
        return value === undefined || (!isNaN(value) && Math.floor(value) === Math.ceil(value));
    },
    isValidYear(values, value) {
        return value === undefined || value === "" || this.isInt(values, value) && (value >= 2014 && value <= new Date().getUTCFullYear());
    },
    isValidMonth(values, value) {
        return value === undefined || value === "" || this.isInt(values, value) && (value >= 0 && value < 12);
    },
    isValidDay(values, value) {
        return value === undefined || value === "" || this.isInt(values, value) && (value >= 1 && value <= 31);
    },
    isValidHour(values, value) {
        return value === undefined || value === "" || this.isInt(values, value) && (value >= 0 && value < 24);
    },
    isValidMinute(values, value) {
        return value === undefined || value === "" || this.isInt(values, value) && (value >= 0 && value < 60);
    },
    isValidSecond(values, value) {
        return value === undefined || value === "" || this.isInt(values, value) && (value >= 0 && value < 60);
    },
    isValidIfOthersDateTimeEmpty(values, value) {
        const relatedValues = ["year", "month", "day", "hour", "minute", "second", "zone"];

        const iExist = value !== undefined && value !== "" && value !== null;
        const othersExist = relatedValues.filter(field => !! values[field]).length;

        if(iExist && othersExist) {
            const curDate = new Date();
            let date = new Date();

            date.setUTCFullYear(parseInt(values.year), parseInt(values.month), parseInt(values.day));
            date.setUTCHours(parseInt(values.hour), (parseInt(values.minute) + parseInt(values.zone)), parseInt(values.second));

            return curDate.getTime() > date.getTime();
        }

        return iExist || !othersExist;
    }
};

export default validators;


/** WEBPACK FOOTER **
 ** ./app/utils/functions/validators.js
 **/